import { useQuery } from "@apollo/client";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { useEffect } from "react";
import { listSweepstakesActive } from "../../../graphql/queries/listSweepstakesActive";
import "./SweepstakesOutcomeSelect.scss";

const AddSweepstakesInfo = (props) => {
  const { handleChange, path } = props || {};
  const ctx = useJsonForms();
  const formData = ctx.core.data;
  const { data: queryData } = useQuery(listSweepstakesActive, {
    variables: {
      filter: {
        page: 0,
        size: 1000,
      },
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (
      formData?.sweepstakes_ids?.length &&
      queryData?.listSweepstakesLatest?.items?.length
    ) {
      const sweepstakesData = queryData?.listSweepstakesLatest?.items?.filter(
        (sweepstakes) => formData?.sweepstakes_ids?.includes(sweepstakes.id)
      );
      const sweepstakesInfo = sweepstakesData?.map((item) => ({
        id: item.id,
        name: item.title,
      }));
      handleChange(path, sweepstakesInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.sweepstakes_ids, queryData?.listSweepstakesLatest]);

  // this component returns nothing
  return null;
};

export const AddSweepstakesInfoControl =
  withJsonFormsControlProps(AddSweepstakesInfo);
export default AddSweepstakesInfo;
